/** Meta OAuth callback (/integrations/meta/callback). */
export const metaCallback = {
  title: "Connect Facebook Messenger",
  docTitle: "Connecting Messenger",
  loading: "Checking your Facebook sign-in…",
  pickTitle: "Choose your Facebook Page",
  pickBody: "Pick the Page the assistant will reply for.",
  pagesLabel: "Facebook Pages",
  noCategory: "Facebook Page",
  connect: "Connect Page",
  connected: "Messenger connected to {{page}}",
  back: "Back to Channels",
  backHome: "Back to console",
  noPagesTitle: "No Pages found",
  noPagesBody: "Facebook didn't share any Pages with Sagot. Make sure the account you sign in with has access to your Page, then tick it in Facebook's popup.",
  sharedPages_one: "Facebook shared {{count}} Page with Sagot.",
  sharedPages_other: "Facebook shared {{count}} Pages with Sagot.",
  sharedPagesPartial_one: "Facebook shared {{count}} Page with Sagot; {{available}} can be connected.",
  sharedPagesPartial_other: "Facebook shared {{count}} Pages with Sagot; {{available}} can be connected.",
  unavailableTitle_one: "{{count}} shared Page can't be connected with this Facebook account",
  unavailableTitle_other: "{{count}} shared Pages can't be connected with this Facebook account",
  unavailableBody: "Facebook let you tick it, but gave Sagot no access to its messages. This happens when your account reaches the Page only through a business portfolio. Give your Facebook account full control of the Page (Meta Business Suite → Settings → Pages → the Page → People), then choose Pages again.",
  unavailableId: "Page ID {{id}}",
  repickTitle: "Don't see your Page?",
  repickBody: "Facebook only shares the Pages you tick in its sign-in popup, and it remembers your earlier choice. To change it, open Facebook → Settings & privacy → Settings → Business integrations, remove this app, then choose Pages again and tick every Page (and its business) you want Sagot to use.",
  repickBusiness: "Pages managed through a Business portfolio only appear if you have access to the Page as a person, not just through the business.",
  repickAction: "Choose Pages again",
  missingPermsTitle: "Facebook didn't share every permission",
  missingPermsBody: "Sagot needs all of these to read and answer Messenger messages on your Page. Grant them, then choose your Pages again.",
  missingPermsList: "Missing permissions",
  notGranted: "Not granted",
  missingPermsAction: "Grant permissions",
  deniedTitle: "Facebook sign-in was cancelled",
  deniedBody: "Nothing was connected. You can try again from Channels whenever you're ready.",
  missingTitle: "This sign-in link has expired",
  missingBody: "Start the connection again from the Channels page of the assistant you want to connect.",
  failedTitle: "We couldn't finish connecting Messenger",
  failedBody: "The sign-in may have expired. Start again from Channels.",
} as const;
